document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  // Match on the hash, not the start of the href: Shopify prefixes menu links
  // with the language path (e.g. "/es-es#quote-modal"), and the modal exists
  // on every page, so it should open instead of navigating.
  const trigger = target.closest('a[href*="#quote-modal"]');
  if (!trigger) return;

  const hash = new URL(trigger.href, window.location.href).hash;
  if (!hash.startsWith('#quote-modal')) return;

  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const modal = document.getElementById('quote-modal');
  if (!modal || typeof modal.showDialog !== 'function') return;

  event.preventDefault();

  const [, query] = hash.split('?');
  const source = new URLSearchParams(query || '').get('source') || '';

  const sourceInput = modal.querySelector('[data-quote-source-input]');
  if (sourceInput instanceof HTMLInputElement) {
    sourceInput.value = source;
  }

  modal.showDialog();
});

// The Forms app renders its "Continue with Shop" button (<shop-lead-capture>)
// inside the shadow root of <shopify-forms-embed>, which page CSS can't reach.
// So the hide rule has to be injected into that shadow root. The wrapper div is
// hidden too, otherwise it leaves an empty gap at the top of the form.
const HIDE_SHOP_LEAD_CAPTURE_CSS =
  'shop-lead-capture, div:has(> shop-lead-capture) { display: none !important; }';
const patchedEmbeds = new WeakSet();

function hideShopLeadCapture() {
  document.querySelectorAll('shopify-forms-embed').forEach((host) => {
    const root = host.shadowRoot;
    if (!root || patchedEmbeds.has(host)) return;
    patchedEmbeds.add(host);

    if ('adoptedStyleSheets' in root && typeof CSSStyleSheet === 'function') {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(HIDE_SHOP_LEAD_CAPTURE_CSS);
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    } else {
      const style = document.createElement('style');
      style.textContent = HIDE_SHOP_LEAD_CAPTURE_CSS;
      root.appendChild(style);
    }
  });
}

hideShopLeadCapture();

let hideScheduled = false;
new MutationObserver(() => {
  if (hideScheduled) return;
  hideScheduled = true;
  requestAnimationFrame(() => {
    hideScheduled = false;
    hideShopLeadCapture();
  });
}).observe(document.documentElement, { childList: true, subtree: true });
